// Formats a 1-based reminder position as a language-appropriate ordinal, e.g. 1 → "1re" / "1st",
// 2 → "2e" / "2nd". French uses "re" for first and "e" thereafter; English uses the usual
// st/nd/rd/th rules including the 11–13 exception.
export const formatRelanceOrdinal = (position: number, language: string): string => {
    if (language.startsWith('fr')) {
        return position === 1 ? `${position}re` : `${position}e`;
    }
    const mod100 = position % 100;
    const mod10 = position % 10;
    if (mod100 >= 11 && mod100 <= 13) return `${position}th`;
    if (mod10 === 1) return `${position}st`;
    if (mod10 === 2) return `${position}nd`;
    if (mod10 === 3) return `${position}rd`;
    return `${position}th`;
};
